import { Mutation } from "./sequtils";
import * as d3 from "d3";
import { DateTime } from "luxon";
import { getCountryId, getProvinceId, getFullProvinceId } from "./locations";
import { getLastItem } from "./utils";
import { PROVINCE_SEPARATOR } from "./constants";


export function loadMutationsData(mutations, countries, overlappingMutationsToggle, dataInitialize, errorCallback) {

  let mutationsPos = mutations.map(mut => {
    let m = new Mutation(mut);
    return `${ m.gene }:${ m.position }`;
  });

  let mutationsQuery = mutations.map(mut => {
    return mut.replace(/\//gi, '-'); // replace / in mutations (like DEL69/70 with a -)
  });

  let hasCountries = countries.length > 0;
  let mutationSeparator = (overlappingMutationsToggle) ? '&' : ',';

  let numUrl, denomUrl, countsUrl;
  let data = [], mostRecentDataDate;
  let promises = [];

  if (hasCountries) {
    countries.forEach((country, i) => {

      let isProvince = false;
      let countryId, provinceId;

      if (country.match(PROVINCE_SEPARATOR)) {
        isProvince = true;
        let tokens = country.split(PROVINCE_SEPARATOR);
        countryId = tokens[0];
        provinceId = tokens[1];
      } else {
        countryId = country;
      }


      if (isProvince) {
        numUrl = `https://wopr.fathom.info/query/bin=date,mutation(${ mutationsPos.join(',') })/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

        denomUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/mutation=*`;

        countsUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

        promises.push(
          loadData(mutations, 'mutation', provinceId, getFullProvinceId(country), false, true, numUrl, denomUrl, countsUrl)
            .then(d => {
              if (!mostRecentDataDate) {
                mostRecentDataDate = d.mostRecentDataDate;
              } else {
                if (d.mostRecentDataDate > mostRecentDataDate) {
                  mostRecentDataDate = d.mostRecentDataDate;
                }
              }
              d.data.forEach(_d => _d.sortIndex = i);
              data = [...data, ...d.data];
            })
        );
      } else {
        numUrl = `https://wopr.fathom.info/query/bin=date,mutation(${ mutationsPos.join(',') })/country=${ countryId }/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

        denomUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/date=2019-12-01:/cleandates/mutation=*`;

        countsUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

        promises.push(
          loadData(mutations, 'mutation', countryId, getCountryId(countryId), true, false, numUrl, denomUrl, countsUrl)
            .then(d => {
              if (!mostRecentDataDate) {
                mostRecentDataDate = d.mostRecentDataDate;
              } else {
                if (d.mostRecentDataDate > mostRecentDataDate) {
                  mostRecentDataDate = d.mostRecentDataDate;
                }
              }
              d.data.forEach(_d => _d.sortIndex = i);
              data = [...data, ...d.data];
            })
        );
      }
    });
  } else {

    // Worldwide

    numUrl = `https://wopr.fathom.info/query/bin=date,mutation(${ mutationsPos.join(',') })/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

    denomUrl = `https://wopr.fathom.info/query/bin=date/date=2019-12-01:/cleandates/mutation=*`;

    countsUrl = `https://wopr.fathom.info/query/bin=date/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

    promises.push(
      loadData(mutations, 'mutation', 'Worldwide', 'worldwide', false, false, numUrl, denomUrl, countsUrl)
        .then(d => {
          if (!mostRecentDataDate) {
            mostRecentDataDate = d.mostRecentDataDate;
          } else {
            if (d.mostRecentDataDate > mostRecentDataDate) {
              mostRecentDataDate = d.mostRecentDataDate;
            }
          }
          d.data.forEach(_d => _d.sortIndex = 0);
          data = [...data, ...d.data];
        })
    );

  }

  Promise.all(promises)
    .then(() => {
      // Fix the order so it's the same as the countries passed in
      data.sort((a, b) => a.sortIndex - b.sortIndex);

      dataInitialize(data, mostRecentDataDate);
    })
    .catch(err => {
      errorCallback(err);
    });

}

export function loadMutationsDataWithLineageBreakdown(mutations, countries, overlappingMutationsToggle, dataInitialize, errorCallback) {

  let mutationsPos = mutations.map(mut => {
    let m = new Mutation(mut);
    return `${ m.gene }:${ m.position }`;
  });

  let mutationsQuery = mutations.map(mut => {
    return mut.replace(/\//gi, '-'); // replace / in mutations (like DEL69/70 with a -)
  });

  let hasCountries = countries.length > 0;
  let mutationSeparator = (overlappingMutationsToggle) ? '&' : ',';

  let data = [], mostRecentDataDate;
  let promises = [];

  if (hasCountries) {
    countries.forEach((country, i) => {

      let isProvince = false;
      let countryId, provinceId;

      if (country.match(PROVINCE_SEPARATOR)) {
        isProvince = true;
        let tokens = country.split(PROVINCE_SEPARATOR);
        countryId = tokens[0];
        provinceId = tokens[1];
      } else {
        countryId = country;
      }


      if (isProvince) {

        let d = {
          location : provinceId,
          location_id : getFullProvinceId(country),
          isProvince : true,
          isCountry : false,
          data : [],
          weeklyData : []
        };

        let url = `https://wopr.fathom.info/query/bin=date,mutation(${ mutationsPos.join(',') }),lineage/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

        promises.push(
          fetch(url)
            .then(res => res.json())
            .then(_data => {
              d.data = _data.bins;
              data[i] = d;
            })
        );


      } else {

        let d = {
          location : countryId,
          location_id : getCountryId(countryId),
          isProvince : false,
          isCountry : true,
          data : [],
          weeklyData : []
        };

        let url = `https://wopr.fathom.info/query/bin=date,mutation(${ mutationsPos.join(',') }),lineage/country=${ countryId }/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

        promises.push(
          fetch(url)
            .then(res => res.json())
            .then(_data => {
              d.data = _data.bins;
              data[i] = d;
            })
        );
      }
    });
  } else {

    // Worldwide

    let d = {
      location : 'Worldwide',
      location_id : 'worldwide',
      isProvince : false,
      isCountry : false,
      data : [],
      weeklyData : []
    };

    let url = `https://wopr.fathom.info/query/bin=date,mutation(${ mutationsPos.join(',') }),lineage/date=2019-12-01:/cleandates/mutation=${ mutationsQuery.join(mutationSeparator) }`;

    promises.push(
      fetch(url)
        .then(res => res.json())
        .then(_data => {
          d.data = _data.bins;
          data[0] = d;
        })
    );

  }

  Promise.all(promises)
    .then(() => {

      // console.log(data);

      dataInitialize(data);
    })
    .catch(err => {
      errorCallback(err);
    });

}

export function loadMutationsDataWithAccessionIds(date, isWeekly, mutations, countries, overlappingMutationsToggle, dataInitialize, errorCallback) {

  let mutationsPos = mutations.map(mut => {
    let m = new Mutation(mut);
    return `${ m.gene }:${ m.position }`;
  });

  let mutationsQuery = mutations.map(mut => {
    return mut.replace(/\//gi, '-'); // replace / in mutations (like DEL69/70 with a -)
  });

  let hasCountries = countries.length > 0;
  let mutationSeparator = (overlappingMutationsToggle) ? '&' : ',';

  let data = [], mostRecentDataDate;
  let promises = [];


  let dateQuery = '';
  if (isWeekly) {
    dateQuery = `${ date.toISODate() }:${ date.plus({days:6}).toISODate() }`;
  } else {
    dateQuery = `${ date.toISODate() }`;
  }


  if (hasCountries) {
    countries.forEach((country, i) => {

      let isProvince = false;
      let countryId, provinceId;

      if (country.match(PROVINCE_SEPARATOR)) {
        isProvince = true;
        let tokens = country.split(PROVINCE_SEPARATOR);
        countryId = tokens[0];
        provinceId = tokens[1];
      } else {
        countryId = country;
      }

      if (isProvince) {

        let d = {
          location : provinceId,
          location_id : getFullProvinceId(country),
          isProvince : true,
          isCountry : false,
          data : {}
        };

        mutationsQuery.forEach(m => {

          let url = `https://wopr.fathom.info/query/bin=accession/country=${ countryId }/province=${ provinceId }/date=${ dateQuery }/cleandates/mutation=${ m }`;

          promises.push(
            fetch(url)
              .then(res => res.json())
              .then(_data => {
                d.data[m] = _data.ids;
                data[i] = d;
              })
          );
        });


      } else {

        let d = {
          location : countryId,
          location_id : getCountryId(countryId),
          isProvince : false,
          isCountry : true,
          data : {},
        };

        mutationsQuery.forEach(m => {
          let url = `https://wopr.fathom.info/query/bin=accession/country=${ countryId }/date=${ dateQuery }/cleandates/mutation=${ m }`;

          promises.push(
            fetch(url)
              .then(res => res.json())
              .then(_data => {
                d.data[m] = _data.ids;
                data[i] = d;
              })
          );
        });
      }
    });
  } else {

    // Worldwide

    let d = {
      location : 'Worldwide',
      location_id : 'worldwide',
      isProvince : false,
      isCountry : false,
      data : {}
    };

    mutationsQuery.forEach(m => {
      let url = `https://wopr.fathom.info/query/bin=accession/date=${ dateQuery }/cleandates/mutation=${ m }`;

      promises.push(
        fetch(url)
          .then(res => res.json())
          .then(_data => {
            d.data[m] = _data.ids;
            data[0] = d;
          })
      );
    });

  }

  Promise.all(promises)
    .then(() => {

      // console.log(data);

      dataInitialize(data);
    })
    .catch(err => {
      errorCallback(err);
    });

}

export function loadLineagesData(lineages, countries, dataInitialize, errorCallback) {

  let hasCountries = countries.length > 0;
  let separator = ',';

  let numUrl, denomUrl, countsUrl;
  let data = [], mostRecentDataDate;
  let promises = [];

  if (hasCountries) {
    countries.forEach((country, i) => {

      let isProvince = false;
      let countryId, provinceId;

      if (country.match(PROVINCE_SEPARATOR)) {
        isProvince = true;
        let tokens = country.split(PROVINCE_SEPARATOR);
        countryId = tokens[0];
        provinceId = tokens[1];
      } else {
        countryId = country;
      }


      if (isProvince) {
        numUrl = `https://wopr.fathom.info/query/bin=date,lineage/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/lineage=${ lineages.join(separator) }`;

        denomUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/lineage=*`;

        countsUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/province=${ provinceId }/date=2019-12-01:/cleandates/lineage=${ lineages.join(separator) }`;

        promises.push(
          loadData(lineages, 'lineage', provinceId, getFullProvinceId(country), false, true, numUrl, denomUrl, countsUrl)
            .then(d => {
              if (!mostRecentDataDate) {
                mostRecentDataDate = d.mostRecentDataDate;
              } else {
                if (d.mostRecentDataDate > mostRecentDataDate) {
                  mostRecentDataDate = d.mostRecentDataDate;
                }
              }
              d.data.forEach(_d => _d.sortIndex = i);
              data = [...data, ...d.data];
            })
        );
      } else {
        numUrl = `https://wopr.fathom.info/query/bin=date,lineage/country=${ countryId }/date=2019-12-01:/cleandates/lineage=${ lineages.join(separator) }`;

        denomUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/date=2019-12-01:/cleandates/lineage=*`;

        countsUrl = `https://wopr.fathom.info/query/bin=date/country=${ countryId }/date=2019-12-01:/cleandates/lineage=${ lineages.join(separator) }`;

        promises.push(
          loadData(lineages, 'lineage', countryId, getCountryId(countryId), true, false, numUrl, denomUrl, countsUrl)
            .then(d => {
              if (!mostRecentDataDate) {
                mostRecentDataDate = d.mostRecentDataDate;
              } else {
                if (d.mostRecentDataDate > mostRecentDataDate) {
                  mostRecentDataDate = d.mostRecentDataDate;
                }
              }
              d.data.forEach(_d => _d.sortIndex = i);
              data = [...data, ...d.data];
            })
        );
      }
    });
  } else {

    // Worldwide

    numUrl = `https://wopr.fathom.info/query/bin=date,lineage/date=2019-12-01:/cleandates/lineage=${ lineages.join(separator) }`;

    denomUrl = `https://wopr.fathom.info/query/bin=date/date=2019-12-01:/cleandates/lineage=*`;

    countsUrl = `https://wopr.fathom.info/query/bin=date/date=2019-12-01:/cleandates/lineage=${ lineages.join(separator) }`;

    promises.push(
      loadData(lineages, 'lineage', 'Worldwide', 'worldwide', false, false, numUrl, denomUrl, countsUrl)
        .then(d => {
          if (!mostRecentDataDate) {
            mostRecentDataDate = d.mostRecentDataDate;
          } else {
            if (d.mostRecentDataDate > mostRecentDataDate) {
              mostRecentDataDate = d.mostRecentDataDate;
            }
          }
          d.data.forEach(_d => _d.sortIndex = 0);
          data = [...data, ...d.data];
        })
    );
  }

  Promise.all(promises)
    .then(() => {
      // Fix the order so it's the same as the countries passed in
      data.sort((a, b) => a.sortIndex - b.sortIndex);

      dataInitialize(data, mostRecentDataDate);
    })
    .catch(err => {
      errorCallback(err);
    });

}


export async function loadData(dataKeys, dataType, location, location_id, isCountry, isProvince, numUrl, denomUrl, countsUrl, dataInitialize, errorCallback) {

  let numerator, denominator, counts;
  //let hasCountries = countries.length > 0;

  let promises = [];
  promises.push(
    fetch(numUrl)
      .then(res => res.json())
      .then(data => {
        numerator = data;
      })
  );
  promises.push(
    fetch(denomUrl)
      .then(res => res.json())
      .then(data => {
        denominator = data;
      })
  );
  promises.push(
    fetch(countsUrl)
      .then(res => res.json())
      .then(data => {
        counts = data;
      })
  );



  return Promise.all(promises)
    .then(() => {

      let dataKeyedByDate = {};
      let dataKeyedByWeek = {};

      //console.log(denominator.bins);
      //console.log(counts.bins);

      for (const date in denominator.bins) {


        let bin = numerator.bins[date];
        let denomBin = denominator.bins[date];
        let countsBin = counts.bins[date];

        let dayBin = {};

        let weekDate = d3.timeWeek(DateTime.fromISO(date));
        weekDate = DateTime.fromJSDate(new Date(weekDate));

        //console.log(date, weekDate);

        dataKeyedByWeek[weekDate.toISODate()] = dataKeyedByWeek[weekDate.toISODate()] || {};
        let weekBin = dataKeyedByWeek[weekDate.toISODate()];

        dataKeys.forEach(key => {
          if (bin && bin[key]) {

            dayBin[key] = {};
            weekBin[key] = weekBin[key] || {};

            let num = 0, denom = 0;
            if (bin[key]) {
              num = bin[key];
            }
            if (denomBin) {
              denom = denomBin;
            }

            let sequencesCount = countsBin || 0;

            getDataFromBins(num, denom, sequencesCount, dayBin, weekBin, key, location);

          }

        });
        dataKeyedByDate[date] = dayBin;
      }

      //console.log(dataKeyedByDate);



      // Decompose the keyed data into timeseries arrays
      let data = [];
      dataKeys.forEach(key => {
        structureTimeseriesData(data, dataKeyedByDate, dataKeyedByWeek, key, dataType, location, location_id, isProvince, isCountry);
      });

      //

      //console.log(data);

      let mostRecentDataDate;

      data.forEach(d => {
        let lastItem = getLastItem(d.data);
        if (lastItem) {
          let lastDate = lastItem.date;
          //console.log(lastDate.toISODate());

          mostRecentDataDate =  null;

          if (!mostRecentDataDate) {
            mostRecentDataDate = lastDate;
          } else {
          //console.log(mostRecentDataDate.diff(lastDate, 'days').days);
            if (mostRecentDataDate.diff(lastDate, 'days').days < 0) {
              mostRecentDataDate = lastDate;
            }
          }
        }
      });

      return {data, mostRecentDataDate};


    });

}



function getDataFromBins(num, denom, count, dayBin, weekBin, dataKey, location) {

  let pct = 0;
  if (denom > 0) {
    pct = num / denom;
  }

  dayBin[dataKey][location] = {num:num, denom:denom, pct:pct, sequencesCount:count};
  weekBin[dataKey][location] = weekBin[dataKey][location] || {num:0, denom:0, pct:0, sequencesCount:0};
  weekBin[dataKey][location].num += num;
  weekBin[dataKey][location].denom += denom;
  weekBin[dataKey][location].sequencesCount += count;
  if (weekBin[dataKey][location].denom > 0) {
    weekBin[dataKey][location].pct = weekBin[dataKey][location].num / weekBin[dataKey][location].denom;
  }

}

function structureTimeseriesData(data, dataKeyedByDate, dataKeyedByWeek, dataKey, dataType, location, location_id, isProvince, isCountry) {

  let d = {
    location : location,
    location_id : location_id,
    isProvince : isProvince,
    isCountry : isCountry,
    data : [],
    weeklyData : [],
    sequencesTotal : 0
  };

  // set the lineage or mutation
  if (dataType === 'mutation') {
    d[dataType] = new Mutation(dataKey);
  } else {
    d[dataType] = dataKey;
  }

  for (const dateKey in dataKeyedByDate) {
    if (dataKeyedByDate[dateKey][dataKey]) {
      d.data.push({
        date: DateTime.fromISO(dateKey),
        pct : dataKeyedByDate[dateKey][dataKey][location].pct,
        num : dataKeyedByDate[dateKey][dataKey][location].num,
        denom : dataKeyedByDate[dateKey][dataKey][location].denom,
        sequencesCount : dataKeyedByDate[dateKey][dataKey][location].sequencesCount
      });
      d.sequencesTotal += dataKeyedByDate[dateKey][dataKey][location].sequencesCount || 0;
    } else {
      d.data.push({
        date: DateTime.fromISO(dateKey),
        // pct : 0,
        // num : 0,
        // denom : 0,
        sequencesCount : 0
      });
    }
  }
  d.data.sort((a, b) => a.date.diff(b.date));

  for (const dateKey in dataKeyedByWeek) {
    if (dataKeyedByWeek[dateKey][dataKey]) {
      d.weeklyData.push({
        date: DateTime.fromISO(dateKey),
        pct : dataKeyedByWeek[dateKey][dataKey][location].pct,
        num : dataKeyedByWeek[dateKey][dataKey][location].num,
        denom : dataKeyedByWeek[dateKey][dataKey][location].denom,
        sequencesCount : dataKeyedByWeek[dateKey][dataKey][location].sequencesCount
      });
    } else {
      d.weeklyData.push({
        date: DateTime.fromISO(dateKey),
        // pct : 0,
        // num : 0,
        // denom : 0,
        sequencesCount : 0
      });
    }
  }
  d.weeklyData.sort((a, b) => a.date.diff(b.date));

  data.push(d);
}
